<template>
	<div class="flip-card" v-if="$store.state.profile">
		<div class="cardWrap" :class="{'flip' : isFlip}">
			<div class="flip-card-front">
				<div class="cardData">
					<div class="header">
						<!-- <div class="photo"><img :src="picHolder || require('../assets/images/photo_ph.svg')" alt=""></div> -->
						<div class="logo">
							<img src="../assets/images/newLogo-old-2.png" alt="">
						</div>
					</div>
          <div class="title">
            <!-- <p>KARTU TANDA ANGGOTA</p>
            <h1>PARTAI PERINDO</h1> -->
            <img src="../assets/images/kta.svg" alt="kta">
          </div>

          <div class="content">
            <div style="display: flex;">
              <div class="photo"><img :src="picHolder || require('../assets/images/photo_ph_2.png')" alt=""></div>
              <div>
                <!-- <h3 class="text-bold">Kartu Tanda Anggota</h3> -->
                <div class="name">
                  <p class="text-bold">{{$store.state.profile.nama_lengkap}}</p>
                  <p class="text-bold">{{$store.state.profile.member_no}}</p>
                </div>
                <div class="bod">{{$store.state.profile.tempat_lahir}} / {{dateConvert($store.state.profile.tanggal_lahir)}}</div>
                <div class="addressWrapper">
                  <div class="address">
                    {{$store.state.profile.alamat}}
                  </div>
                </div>
                <div class="phone">
                  Telp : {{$store.state.profile.phone_number}}
                </div>
              </div>
            </div>
            <div><div class="qrcode">
							<img src="../assets/images/qr-code.svg" alt="qr-code">
						</div></div>
            <!-- <div><div class="qrcode" style="width: 100px; height: 100px;">
							<img src="../assets/images/qr-code.svg" alt="qr-code">
						</div></div> -->
          </div>
					<!-- <h3 class="text-bold">Kartu Tanda Anggota</h3>
          <div class="name">
            <span class="text-bold">{{$store.state.profile.nama_lengkap}}</span>
            <span class="text-bold">{{$store.state.profile.member_no}}</span>
          </div>
					<div class="bod">{{$store.state.profile.tempat_lahir}}/{{dateConvert($store.state.profile.tanggal_lahir)}}</div>
					<div class="addressWrapper">
						<div class="address">
							{{$store.state.profile.alamat}}
						</div>
						<div class="qrcode" style="width: 100px; height: 100px;">
							<img src="../assets/images/qr-code.svg" alt="qr-code">
						</div>
					</div> -->
          <!-- <div class="phone">
            Telp : {{$store.state.profile.phone_number}}
          </div> -->
				</div>
			</div>
			<div class="flip-card-back">
        <!-- <img src="../assets/images/back-card.jpg" alt=""> -->
        <img src="../assets/images/kta-back-card-2025.jpg" alt="">
			</div>
		</div>
	</div>
</template>
<script>
import helperMixin from '@/mixins/helper.js'
import axios from 'axios'
export default {
  props: ['isFlip'],
  mixins: [helperMixin],
  data () {
    return {
      picHolder: null
    }
  },
  methods: {
    dateConvert (date) {
      const splited = date.split('-')
      return `${splited[2]}-${splited[1]}-${splited[0]}`
    },
    async getProfilePic () {
      const getRandomNumberBetween = (min, max) => {
        return Math.floor(Math.random() * (max - min + 1) + min)
      }
      try {
        const ktp = await axios.get(`member/member/photoprofile?r=${getRandomNumberBetween(0, 100)}&r2=${getRandomNumberBetween(0, 100)}`, {
          responseType: 'blob',
          headers: {
            'content-type': 'image/jpeg'
          }
        })
        const urlCreator = window.URL || window.webkitURL
        this.picHolder = urlCreator.createObjectURL(ktp.data)
      } catch (err) {
        // this.alertFailed(err.message)
      }
    }
  },
  mounted () {
    this.getProfilePic()
  }
}
</script>
<style lang="scss" scoped>
    .flip-card {
      perspective: 1000px;

        .cardWrap {
          position: relative;
          height: 0;
          padding-top: 300px / 491px * 100%;
          background-color: #fff;
          width: 100%;
          height: 100%;
          -webkit-transition: transform 0.6s;
          transition: transform 0.6s;
          -webkit-transform-style: preserve-3d;
          transform-style: preserve-3d;
          // @media screen and (min-width: 320px) and (max-width: 480px) {
          //   padding: 33%;
          // }
          @media (min-width: 481px) and (max-width: 767px) {
            padding-top: 56%;
          }
          // @media screen and (min-width: 768px) and (max-width: 1024px) {
          //   padding-top: 57%;
          // }

          img.cardImg {
            border-radius: 10px;
            box-shadow: -1px 2px 70px 0px #21409a87;
          }

          .flip-card-front {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: grid;
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;

            .cardData {
              .header{
                display: flex;
                justify-content: center;
                width: 100%;
                .logo {
                  width: 93px;
                  @media screen and (min-width: 320px) and (max-width: 480px) {
                    // width: 70px;
                    width: 60px;
                  }
                  @media (min-width: 481px) and (max-width: 767px) {
                    width: 72px;
                  }
                }
              }
              .title {
                background: linear-gradient(to right, #1d3b82 20%, #9b2f5d 70%, #d1272d 100%);
                padding: 12px 0;
                @media screen and (min-width: 320px) and (max-width: 767px) {
                  padding: 8px 0;
                }
                p {
                  font-size: 14px;
                  font-weight: 600;
                  margin-bottom: 0;
                  color: #ffffff;
                  text-align: center;
                }
                h1 {
                  font-size: 20px;
                  font-weight: bold;
                  color: #ffffff;
                  text-align: center;
                }
                img {
                  width: 270px;
                  margin: 0 auto;
                  @media screen and (min-width: 320px) and (max-width: 767px) {
                    width: auto;
                  }
                }
              }
              .content {
                display: flex;
                justify-content: space-between;
                padding: 15px 14px 12px 20px;
                @media screen and (min-width: 320px) and (max-width: 767px) {
                  padding: 6px 10px 10px 10px;
                }
                .photo {
                  background-color: #000000;
                  height: 100%;
                  width: 90px;
                  // width: max-content;
                  // height: 95px;
                  height: 83px;
                  display: flex;
                  padding: 5px 1px 1px 1px;
                  margin-bottom: .5rem;
                  margin-right: 8px;
                  justify-content: center;
                  @media screen and (min-width: 320px) and (max-width: 767px) {
                    // width: 70px;
                    // height: 70px;
                    width: 63px;
                    height: 63px;
                  }
                  @media (min-width: 768px) and (max-width: 1024px) {
                    // width: 90px;
                    // height: 90px;
                    width: 86px;
                    height: 86px;
                  }
                  img {
                    object-fit: cover;
                  }
                }
                .qrcode {
                  width: 70px;
                  height: 70px;
                  @media screen and (min-width: 768px) {
                    width: 90px;
                    height: 90px;
                  }
                }
              }

              .profile-wrapper {
                width: 85px;
                .supersmall {
                  font-size: 10px;
                  letter-spacing: 0.6px;
                }
                h3 {
                  line-height: 0.5;
                  font-size: 16px;
                }
              }

              .nik {
                font-size: 18px;
                margin-bottom: .7rem;
              }

              .name {
                font-size: 16px;
                margin-top: .3rem;
                display: flex;
                flex-direction: column;
                line-height: 1.2rem;
                text-transform: capitalize;
                font-family: 'Gotham Bold';
                @media screen and (min-width: 320px) and (max-width: 767px) {
                  font-size: 12px;
                  line-height: .9rem;
                }
                p {
                  margin-bottom: 0;
                }
              }

              .bod {
                font-size: 12px;
                font-weight: 400;
                font-family: 'Gotham Book';
                line-height: 13px;
                font-weight: 400;
                width: 83%;
                margin-bottom: 4px;
                @media screen and (min-width: 320px) and (max-width: 767px) {
                  font-size: 7px;
                  margin-bottom: 0;
                }
              }

              .addressWrapper {
                display: flex;
                justify-content: space-between;
                align-items: center;
                max-width: 300px;
                font-size: 12px;
                font-family: $gotham-book;
                @media screen and (min-width: 320px) and (max-width: 767px) {
                  font-size: 7px;
                  max-width: 168px;
                }
                @media screen and (min-width: 768px) and (max-width: 1024px) {
                  max-width: 276px;
                }

                .address {
                  width: 90%;
                  font-size: 12px;
                  line-height: 13px;
                  text-transform: capitalize;
                  font-weight: 400;
                  @media screen and (min-width: 320px) and (max-width: 767px) {
                    width: 86%;
                    font-size: 7px;
                    line-height: 9.1px;
                  }
                }
              }
              .phone {
                margin-top: 10px;
                font-size: 12px;
                font-family: 'Gotham Book';
                @media screen and (min-width: 320px) and (max-width: 767px) {
                  font-size: 7px;
                }
              }

              h3 {
                font-size: 16px;
                font-family: 'Gotham Bold';
              }
            }

          }

          .flip-card-back {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            transform: rotateY(180deg);
            -webkit-transform: rotateY(-180deg);
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
          }

          &.flip {
            transform: rotateY(180deg);
            -webkit-transform: rotateY(180deg);
          }

        }
    }
</style>
